var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",staticStyle:{"visibility":"hidden"}},_vm._l((_vm.renderQueue),function({creationModel, renderCallback}){return _c('template-holder',{key:creationModel.id,attrs:{"creationModel":creationModel,"listenToChanges":false,"skip-mirror-register":true,"mount-callback":renderCallback}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }